import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import InquiryThread from './InquiryThread';
import { getDevInquiry, sendDevReply, setInquiryStatus } from '../../api/inquiriesApi';

const DEV_API = { load: getDevInquiry, send: sendDevReply };

/** 送った人の情報（名前・メール・ロール・主店舗・端末）と、対応済みの切り替え。メールの結果が failed なら、目立たせる。 */
function AuthorCard({ thread, setThread }) {
  const { id } = useParams();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const a = thread.author || {};
  const closed = thread.status === 'closed';

  const toggle = async () => {
    setBusy(true);
    setError('');
    try {
      const next = closed ? 'open' : 'closed';
      await setInquiryStatus(id, next);
      setThread((t) => ({ ...t, status: next }));
    } catch (err) {
      setError(err.message || '切り替えに失敗しました');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="inq-author">
      <dl>
        <div><dt>名前</dt><dd>{a.name || '（不明）'}</dd></div>
        <div><dt>メール</dt><dd>{a.email || '（不明）'}</dd></div>
        <div><dt>ロール</dt><dd>{a.role || '（不明）'}</dd></div>
        <div><dt>主店舗</dt><dd>{a.homeStore || '（なし）'}</dd></div>
        <div><dt>端末</dt><dd>{thread.userAgent || '（不明）'}</dd></div>
      </dl>
      {thread.mail === 'failed' && <div className="inq-warn">開発者へのメール通知が失敗していました</div>}
      {error && <div className="help-error" role="alert">{error}</div>}
      <button type="button" className="inq-toggle" disabled={busy} onClick={toggle}>
        {closed ? '未対応に戻す' : '対応済みにする'}
      </button>
    </div>
  );
}

/**
 * 開発者用のお問い合わせのやり取り（/settings/help/dev/:id）。返信すると、送った本人にプッシュ通知が届く。
 * 本人の「読んだ印」は付かない。dev 以外は、サーバーが 403 で断る（画面は「開発者のみ利用できます」）。
 */
export default function DevInquiryThread() {
  return (
    <InquiryThread
      viewer="dev"
      api={DEV_API}
      backTo="/settings/help/dev"
      backLabel="一覧"
      placeholder="返信を入力（送った本人に通知が届きます）"
      extraHeader={(thread, setThread) => <AuthorCard thread={thread} setThread={setThread} />}
    />
  );
}
